/** @jsxRuntime classic */
/** @jsx jsx */
import { blocksQuery } from 'api';
import { LogError } from 'business/constants';
import PageLayout from 'components/ui-components/layout/PageLayout';
import SEO from 'components/utility-wrappers/seo';
import { Fragment, useEffect } from 'react';
import useSWR from 'swr';
import { jsx } from 'theme-ui';
import { changeBgColor, createBlocks } from 'utils/helpers';

const request = {
  params: {},
  query: `*[_type == 'page' && _id == 'contact' && !(_id in path("drafts.**"))]{
    title,
    seo,
    backgroundcolor,
    ${blocksQuery}
  }[0]`,
};

const Contact = (props) => {
  const { data, error } = useSWR([request.query.toString(), request.params]);

  useEffect(() => {
    changeBgColor(data?.backgroundcolor || props.color);
  }, [props.color, data]);

  if (error || !data) {
    error && LogError(request.query, request.params, error);
    return null;
  }

  const { seo = {}, title, blocks } = data;

  return (
    <Fragment>
      <SEO title={title} {...seo} />
      <PageLayout>{createBlocks(blocks)}</PageLayout>
    </Fragment>
  );
};

export default Contact;
